import React from 'react';
import PropTypes from 'prop-types';

import SimpleButton from 'styled/Buttons/SimpleButton';

import RotatedChevron from './RotatedChevron';

const PopupButton = props => (
  <SimpleButton
    type="button"
    onClick={props.onClick}
    style={{ padding: '6px 0' }}
  >
    {props.label}

    <RotatedChevron style={{ transform: props.isPopupOpen ? 'rotate(180deg)' : '' }} />
  </SimpleButton>
);

PopupButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  isPopupOpen: PropTypes.bool,
};

PopupButton.defaultProps = {
  label: '',
  onClick: () => {},
  isPopupOpen: false,
};

export default PopupButton;
